<div class="bg-comments">

  <div class="comments-header">
    <h2 class="comments-title">¡Las experiencias hablan por nosotros!</h2>
    <p class="comments-subtitle">
      En Traveler Assistance, la confianza de nuestros viajeros se construye con respuestas reales, atención oportuna y acompañamiento constante en cada momento del viaje.
    </p>
  </div>

  <div class="carousel-stage" (mouseenter)="pauseAutoplay()" (mouseleave)="startAutoplay()">
    <div
      class="review-slot"
      [class.is-active]="i === activeIndex"
      [class.is-prev]="i === prevIndex"
      [class.is-next]="i === nextIndex"
      *ngFor="let review of reviews; let i = index"
    >
      <div class="review-card">
        <div class="review-card__quote">&ldquo;</div>
        <p class="review-card__text">{{ review.content }}</p>
        <div class="review-card__rating">
          <img [src]="review.badgeImg" [alt]="review.badge" class="review-card__badge" loading="lazy" />
        </div>
        <div class="review-card__author">
          <img [src]="review.avatar" [alt]="review.name" class="review-card__avatar" loading="lazy" />
          <p class="review-card__name">{{ review.name }}</p>
        </div>
      </div>
    </div>
  </div>

</div>
